<script>
	import { getContext, onMount } from 'svelte';

	const { width, height, xScale, yScale, yRange } = getContext('LayerCake');

	export let gridlines = true;
	export let formatTick = d => d;
	export let baseline = false;
	export let snapTicks = false;
	export let ticks = undefined;
	export let xTick = undefined;
	export let yTick = 16;
	export let dxTick = 0;
	export let dyTick = 0;
	export let rotateText = false;

	onMount(()=> {
		if(rotateText) yTick = 7;
	})

	$: isBandwidth = typeof $xScale.bandwidth === 'function';

	$: tickVals = Array.isArray(ticks) ? ticks :
		isBandwidth ?
			$xScale.domain() :
			$xScale.ticks(ticks);

	function textAnchor(i) {
		if(rotateText) {
			return 'end';
		} else {
			if (snapTicks === true) {
				if (i === 0) {
					return 'start';
				}
				if (i === tickVals.length - 1) {
					return 'end';
				}
			}
			return 'middle';
		}
	}
</script>

<g class='axis x-axis'>
	{#each tickVals as tick, i}
		<g class='tick tick-{ tick }' transform='translate({$xScale(tick)},{$yRange[0]})'>
			{#if gridlines !== false}
				<line y1='{$height * -1}' y2='0' x1='0' x2='0'></line>
			{/if}
			<text class="{rotateText? 'rotate' : ''}"
				x="{xTick || isBandwidth ? $xScale.bandwidth() / 2 : 0 }"
				y='{yTick}'
				dx='{dxTick}'
				dy='{dyTick}'
				text-anchor='{textAnchor(i)}'>{formatTick(tick)}</text>
		</g>
	{/each}
	{#if baseline === true}
		<line class="baseline" y1='{$height + 0.5}' y2='{$height + 0.5}' x1='0' x2='{$width}'></line>
	{/if}
</g>

<style lang="scss">
	.tick {
		font-size: .725em;
		font-weight: 200;
	}

	line,
	.tick line {
		stroke: #aaa;
		stroke-dasharray: 2;
	}

	.tick text {
		fill: #666;
	}
	.rotate {
		transform: rotate(-45deg);
		left: 0;
	}

	.baseline {
		stroke-dasharray: 0;
	}
</style>
